import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import emailjs from "@emailjs/browser";
import "./festival.css";
import "react-datepicker/dist/react-datepicker.css";
export default function Festival() {
  let navigate = useNavigate();

  const form = useRef();
  const [displayErr, setDisplayErr] = useState(false);

  function sendEmail(e) {
    e.preventDefault();
    if (
      !festivalQuote.deliveryDate ||
      !festivalQuote.collectionDate ||
      form.current.firstName.value.length < 1 ||
      form.current.lastName.value.length < 1 ||
      form.current.email.value.length < 1
    ) {
      displayErrMsg();
      return;
    }
    emailjs
      .sendForm(
        "service_mfsip79",
        "template_fefdifw",
        form.current,
        "user_2llXx0wmUZW2esUxwtHRS"
      )
      .then(
        (result) => {
          console.log(result.text);
          navigate("/confirmation");
        },
        (error) => {
          console.log(error.text);
        }
      );
  }
  function formatDateString(d) {
    return d.toString().split(" ").slice(1, 4).join(" ");
  }

  const [festivalQuote, setFestivalQuote] = useState({
    guests: 0,
    eventType: "festival",
    w3wCode: "",
    postcode: "",
    deliveryDate: new Date(),
    collectionDate: new Date(),
  });

  function displayErrMsg() {
    setDisplayErr(true);
    window.setTimeout(() => {
      setDisplayErr(false);
    }, 5000);
  }

  return (
    <div className="festival-wrapper">
      <img alt="" className="panel-img fest-img" src={"./imgs/festival.png"} />

      <div className="page-portion">
        <div className="portion-item">
          <h2 className="sub-header cat-title">Where & </h2>
          <h2 className="sub-header cat-title"> when</h2>
        </div>
        <div className="portion-item portion-vertical-flex">
          <div className="where-when">
            <p>WHERE?</p>
            <p>Use What3Words or postcode </p>
            <p>to locate your site.</p>
          </div>
          <div className="datepicker">
            <h2 className="sub-header">Post Code</h2>

            <input
              type="text"
              optional
              placeholder="Postcode"
              onChange={(e) =>
                setFestivalQuote({ ...festivalQuote, postcode: e.target.value })
              }
              className="where-when-input"
            />
            <h2 className="sub-header">OR</h2>
            <h2 className="sub-header">What3Words Code</h2>

            <input
              type="text"
              optional
              placeholder="W3W Code"
              onChange={(e) =>
                setFestivalQuote({ ...festivalQuote, w3wCode: e.target.value })
              }
              className="where-when-input"
            />
          </div>
        </div>
        <div className="portion-item portion-vertical-flex">
          <div className="where-when">
            <p>WHEN?</p>
            <p>We always arrive the day before </p>
            <p>to set up and install</p>
          </div>
          <div className="datepicker">
            <h2 className="sub-header">Delivery Date</h2>
            <DatePicker
              selected={festivalQuote.deliveryDate}
              onChange={(date) =>
                setFestivalQuote({ ...festivalQuote, deliveryDate: date })
              }
              dateFormat="dd/MM/yyyy"
              className="where-when-input-date"
            />
                        <h2 className="sub-header">AND</h2>

            <h2 className="sub-header">Collection Date</h2>
            <DatePicker
              selected={festivalQuote.collectionDate}
              onChange={(date) =>
                setFestivalQuote({ ...festivalQuote, collectionDate: date })
              }
              dateFormat="dd/MM/yyyy"
              className="where-when-input-date"
            />
          </div>
        </div>
      </div>
      <img alt="" className="panel-img fest-img" src={"./imgs/almostfinished.png"} />

      <div className="in-summary">
        <div className="summary-portion-item">
          <h2 className="sub-header cat-title">your </h2>
          <h2 className="sub-header cat-title"> details</h2>
        </div>
        <form
          ref={form}
          className="summary-portion-item contact-form double-box"
          onSubmit={sendEmail}
        >
          <input
            className="hidden-input"
            type="text"
            value={formatDateString(festivalQuote.deliveryDate)}
            name="delDate"
          />
          <input
            className="hidden-input"
            type="text"
            value={formatDateString(festivalQuote.collectionDate)}
            name="colDate"
          />
          <input
            className="hidden-input"
            type="text"
            value={festivalQuote.guests}
            name="guests"
          />

          <input
            className="hidden-input"
            type="text"
            value={festivalQuote.w3wCode}
            name="w3w"
          />
          <input
            className="hidden-input"
            type="text"
            value={festivalQuote.postcode}
          />
          <input
            className="contact-form-input sml-input"
            type="text"
            placeholder="First Name"
            name="firstName"
            required
          />
          <input
            className="contact-form-input sml-input"
            type="text"
            placeholder="Last Name"
            name="lastName"
            required
          />
          <input
            className="contact-form-input"
            type="text"
            placeholder="Phone Number"
            name="phoneNumber"
            required
          />
          <input
            className="contact-form-input"
            type="email"
            placeholder="Email"
            name="email"
            required
          />
          <textarea
            className="contact-form-input"
            type="text"
            placeholder="Comments"
            name="message"
          />
        </form>
        <div className="summary-portion-item" onClick={sendEmail}>
          <div className="complete">
            <img alt="" className="complete-img" src="./imgs/tick.png" />
            <h2 className="sub-header">click to complete</h2>
            {displayErr && (
              <p>
                Looks like you missed some options! Check again before
                submitting
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
